import React from 'react';
import { useSelector } from 'react-redux';
import { List, ListItem } from './index';

const SeriesList = ({ activeSeries, setActiveSeries }) => {
    const series = useSelector(state => state.courseList.series.series);

    return (
        <List>
            {series.map((item, index) => (
                <ListItem key={index} onClick={() => setActiveSeries(index)} active={activeSeries === index}>
                    {item.name}
                </ListItem>
            ))}
        </List>
    );
};

export default SeriesList;
